import { axiosGet, axiosPost } from '../../util/api'
import type { UpgradeItemsResponse, UpgradeReviewResponse } from './review-types'

// Both reads render their own error state; keep the shared toast quiet.
export const getUpgradeReview = (recipeId?: string): Promise<UpgradeReviewResponse> =>
    axiosGet('recipes/upgrades', recipeId ? { recipe_id: recipeId } : null, false, {
        ignore: true,
    }).then((response) => response.data as UpgradeReviewResponse)

export const getUpgradeItems = (recipeId: string): Promise<UpgradeItemsResponse> =>
    axiosGet(`recipes/${recipeId}/upgrade/items`, null, false, { ignore: true }).then(
        (response) => response.data as UpgradeItemsResponse,
    )

export const upgradeRecipe = (recipeId: string): Promise<unknown> =>
    axiosPost(`recipes/${recipeId}/upgrade`)

export const upgradeAllRecipes = (recipeIds: string[]): Promise<{ accepted?: number }> =>
    axiosPost('recipes/upgrades/upgrade-all', { recipe_ids: recipeIds }).then(
        (response) => response.data,
    )
